import React from 'react';
import { withRouter } from 'react-router-dom';
import 'whatwg-fetch';
import moment from 'moment';
import { connect } from 'react-redux';
import { get, set } from 'lodash';
import {
  showNotification as showNotificationAction,
  translate as t,
  GET_LIST,
  Restricted,
  ViewTitle,
} from 'admin-on-rest';
import {
  SelectField,
  MenuItem,
  RaisedButton,
  // DatePicker,
  Checkbox,
  Card,
  CircularProgress,
  RadioButtonGroup,
  RadioButton,
  // Toggle,
} from 'material-ui';
import md5 from 'md5';
import fileDownload from 'js-file-download';

import 'react-pivottable/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
// import { aggregators } from 'react-pivottable/Utilities';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';

import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';
import preloader from '../utils/preloader';
import {
  formatVenues,
  formatProducts,
  dataConfigFormatter,
  setDefaultsOnProducts,
  filterProductsByMarket,
  setAreaOnVenue,
  filterVenuesByMarket,
  filterCategoriesByMarket,
  addAliasToProduct,
  createSimilarProducts,
  filterData,
} from './utils';
import VenueComponent from './venues';
import ProductComponent from './products';
import { hasPositions, isSuperUser } from '../../utils/permissionsUtils';

import './styles.css';

import firestore from '../../config/firestore-init';
import GuestsComponent from './guests';
import DPicker from '../inputs/DatePicker';

const PivotTableUI = preloader(() => import('react-pivottable/PivotTableUI'));
const Plot = preloader(() => import('react-plotly.js'));

const url = (type) => `https://bigdata.pinchos.se/${type}/pivot/json`;
// const url = (type) => `http://ronnie.pinchos.se:3005/${type}/pivot/json`;
const urlcsv = (type) => `https://bigdata.pinchos.se/${type}/pivot/csv/`;

const SHARED_SECRET = process.env.REACT_APP_SHARED_SECRET;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

// create Plotly renderers via dependency injection
const PlotlyRenderers = createPlotlyRenderers(Plot);

const venuesByPermission = ({ venues, user, beverageManager }) => {
  const userVenues = user.venues || [];
  if (user.beverageManager && beverageManager) {
    return venues.filter((venue) => userVenues.includes(venue.name));
  }
  if (isSuperUser(user)) {
    return venues;
  }
  return venues.filter((venue) => userVenues.includes(venue.name));
};

const setVenues = ({ initialVenues, market, locale, user, areaManagers, beverageManager }) => {
  const permittedVenues = venuesByPermission({ venues: initialVenues, user, beverageManager });
  const formattedVenues = dataConfigFormatter(permittedVenues, locale);
  const allVenues = setAreaOnVenue(formattedVenues, areaManagers);
  const venuesByMarket = allVenues.filter((venue) => venue.market.countryCode === market);
  return { venuesByMarket, allVenues };
};

export class Statistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      products: [],
      productsByMarket: [],
      allVenuesSelected: false,
      allProductsSelected: false,
      searchText: '',
      isLoadingFetch: false,
      isLoadingState: true,
      perGuest: false,
      period: 'daily',
      dateTo: moment()._d,
      dateFrom: moment().startOf('month')._d,
      download: false,
      market: '',
      categories: [],
      urlType: 'sales',
      tabbedState: 'sales',
    };
  }

  componentWillMount = async () => {
    const users = await firestore.collection('areaManagers').get().then((querySnapshot) => {
      if (!querySnapshot.exists) {
        return [];
      }
      const usrs = [];
      querySnapshot.forEach((doc) => doc.data().user.get()
        .then((snapShot) => usrs.push(snapShot.data()
        ))
      );
      return usrs;
    });
    this.setState({ areaManagers: users });

    await restClient(GET_LIST, 'venues', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((venues) => {
        const { venuesByMarket, allVenues } = setVenues({
          initialVenues: venues.data,
          market: 'SE',
          locale: this.props.locale,
          user: this.props.user,
          areaManagers: this.state.areaManagers,
          beverageManager: true,
        });
        this.setState({ rawVenues: venues.data, initialVenues: allVenues, venues: venuesByMarket, venuesByMarket, market: 'SE' });
      })
      .catch((e) => { console.log('Venues fetch Error', e); this.props.showNotification('Could not get venues', 'warning'); });

    await restClient(GET_LIST, 'alias', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((alias) => {
        this.setState({ alias: alias.data });
      })
      .catch(() => this.props.showNotification('Could not get markets', 'warning'));

    await restClient(GET_LIST, 'products', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((products) => {
        const formattedProducts = dataConfigFormatter(products.data, this.props.locale);
        const withAlias = addAliasToProduct(formattedProducts, this.state.alias);
        const withDefaults = setDefaultsOnProducts(withAlias);
        const withSimilarProducts = createSimilarProducts(withDefaults);
        console.log('withSimilarproducts', withSimilarProducts);
        const filteredByMarket = filterProductsByMarket(withSimilarProducts, 'SE');
        console.log('filteredByMarket', filteredByMarket);
        this.setState({ initialProducts: withSimilarProducts, productsByMarket: filteredByMarket, products: filteredByMarket, allProductsSelected: true });
      })
      .catch((e) => { console.log('Products fetch Error', e); this.props.showNotification('Could not get products', 'warning'); });

    await restClient(GET_LIST, 'categories', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((cats) => {
        const categoriesByMarket = cats.data.filter((cat) => cat.markets.some((market) => market.countryCode === 'SE'));
        this.setState({ initialCategories: cats.data, categoriesByMarket });
      })
      .catch(() => this.props.showNotification('Could not get categories', 'warning'));

    await restClient(GET_LIST, 'markets', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((markets) => {
        const initialMarket = markets.data.find((mrkt) => mrkt.countryCode === 'SE');
        this.setState({ markets: markets.data, market: initialMarket });
      })
      .catch(() => this.props.showNotification('Could not get markets', 'warning'));


    this.setState({ isLoadingState: false });
  }

  onDateFromChange = (date) => this.setState({ dateFrom: date });

  onDateToChange = (date) => this.setState({ dateTo: date });

  handleSubmit = async () => {
    this.setState({ isLoadingFetch: true });
    const { venues, products, dateTo, dateFrom, period, market, productsByMarket, allProductsSelected } = this.state;
    let language;
    // special case for denmark because they use english in their register
    if (market && market.countryCode === 'DK') {
      language = 'en';
    } else {
      language = market.languageCodes[0];
    }
    const body = {
      venues: venues.length > 0 ? formatVenues(venues, language) : undefined,
      // products: products.length > 0 ? formatProducts(products, language) : undefined,
      products: formatProducts(productsByMarket, language),
      period: {
        to: moment(dateTo).format('YYYYMMDD'),
        from: moment(dateFrom).format('YYYYMMDD'),
        period,
      },
      code: md5(`${SHARED_SECRET}${moment().utc().format('YYMMDD')}${SHARED_SECRET}`),
      showSales: false,
    };

    // if (this.state.allProductsSelected) {
    body.allProducts = true;
    // }

    if (this.state.tabbedState === 'guests') {
      body.states = this.state.booking;
      body.dateSource = this.state.dateSource;
      delete body.products;
      delete body.allProducts;
      if (this.state.onlyDrops) {
        body.onlyDrops = true;
      }
    }

    if (isSuperUser(this.props.user) || hasPositions(this.props.user, ['restaurantManager', 'franchisees'])) {
      body.showSales = true;
    }

    if (this.state.download) {
      try {
        const res = await fetch(urlcsv(this.state.urlType),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept-Charset': 'utf-8',
            },
            mode: 'cors',
            body: JSON.stringify(body),
          });

        const data = await res.text().then((d) => d);

        fileDownload(data, 'statistics.csv');
        this.setState({ isLoadingFetch: false });
        // console.log('QueryData', data);
        return;
      } catch (e) {
        this.setState({ isLoadingFetch: false });
        this.props.showNotification('Failed to get data.', 'warning');
        return;
      }
    }
    console.log('body', body);
    try {
      const res = await fetch(url(this.state.urlType),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Charset': 'utf-8',
          },
          mode: 'cors',
          body: JSON.stringify(body),
        });

      const data = await res.json().then((d) => d);
      let filteredData = filterData(data, products, allProductsSelected);
      if (this.state.tabbedState === 'guests') {
        const periodIndex = filteredData[0].indexOf('Period');
        const hourIndex = filteredData[0].indexOf('Hour');
        filteredData = filteredData.slice(1).map((row) => {
          const formattedPeriod = moment.utc(
            `${get(row, periodIndex)} UTC`,
            'YY/MM/DD HH:mm z'
          );
          const newRow = { ...row };
          console.log('newRow pre', newRow);
          set(newRow, periodIndex, moment(formattedPeriod).local().format('YY/MM/DD HH:mm'));
          console.log('newRow post period', newRow);
          set(newRow, hourIndex, moment(formattedPeriod).local().format('HH'));
          console.log('newRow post hour', newRow);
          return newRow;
        });
        filteredData.unshift(data[0]);
        console.log('filteredData', filteredData);
      }
      this.setState({ [`${this.state.tabbedState}-data`]: filteredData, s: {}, isLoadingFetch: false });
      // console.log('QueryData', data);
    } catch (e) {
      this.setState({ isLoadingFetch: false });
      this.props.showNotification('Failed to get data.', 'warning');
    }
  }

  handleOnCheck = () => this.setState((prevState) => ({ download: !prevState.download }))

  handlePeriodChange = (event, index, value) => this.setState({ period: value })

  pivotHandleChange = (s) => {
    const savedOptions = { ...s };
    delete savedOptions.data;
    this.setState({ s, [`${this.state.tabbedState}-pivotOptions`]: savedOptions });
  };

  handleMarketChange = (event, index, value) => {
    const { countryCode } = value;
    const { initialVenues, initialProducts, initialCategories } = this.state;
    const venuesByMarket = filterVenuesByMarket(initialVenues, countryCode);
    const productsByMarket = filterProductsByMarket(initialProducts, countryCode);
    const categoriesByMarket = filterCategoriesByMarket(initialCategories, countryCode);
    this.setState({ market: value, venues: venuesByMarket, venuesByMarket, products: productsByMarket, productsByMarket, categoriesByMarket });
  }

  handleRadioGuestsChange = (e, value) => {
    const { areaManagers, rawVenues, market: { countryCode }, venues } = this.state;
    const { user, locale } = this.props;
    if (value === 'guests') {
      const { venuesByMarket, allVenues } = setVenues({
        initialVenues: rawVenues,
        market: countryCode,
        locale,
        user,
        areaManagers,
        beverageManager: true,
      });
      return this.setState({
        tabbedState: value,
        urlType: value === 'guests' ? 'guests' : 'sales',
        s: {},
        venues: venuesByPermission({ venues, user, beverageManager: true }),
        venuesByMarket,
        initialVenues: allVenues,
      });
    }

    const { venuesByMarket, allVenues } = setVenues({
      initialVenues: rawVenues,
      market: countryCode,
      locale,
      user,
      areaManagers,
      beverageManager: true,
    });

    return this.setState({
      tabbedState: value,
      urlType: value === 'guests' ? 'guests' : 'sales',
      s: {},
      venues: venuesByPermission({ venues, user, beverageManager: false }),
      venuesByMarket,
      initialVenues: allVenues,
    });
  }
  handleBookingsChange = (value, onlyDrops) => this.setState({ booking: value, onlyDrops: !!onlyDrops });
  handleSeatingChange = (value) => this.setState({ dateSource: value })

  handleProductsChange = (products, allProductsSelected, drinks) => {
    const { rawVenues, market: { countryCode }, areaManagers, venues } = this.state;
    const { locale, user } = this.props;
    if (drinks) {
      const { venuesByMarket, allVenues } = setVenues({
        initialVenues: rawVenues,
        market: countryCode,
        locale,
        user,
        areaManagers,
        beverageManager: false,
      });
      return this.setState({
        products,
        allProductsSelected,
        venues,
        venuesByMarket,
        initialVenues: allVenues,
      });
    }
    const { venuesByMarket } = setVenues({
      initialVenues: rawVenues,
      market: countryCode,
      locale,
      user,
      areaManagers,
      beverageManager: true,
    });
    return this.setState({ products, allProductsSelected, venues: venuesByPermission({ venues, user, beverageManager: true }), venuesByMarket });
  }
  handleVenuesChange = (venues, cluster) => {
    this.setState({ venues, cluster });
  }

  render() {
    const { location, translate } = this.props;
    const {
      initialCategories,
      venuesByMarket,
      venues,
      market,
      areaManagers,
      tabbedState,
      products,
      productsByMarket,
      categoriesByMarket,
      markets,
      dateTo,
      dateFrom,
    } = this.state;
    // console.log('index props', this.props, this.state);

    return (
      <Restricted authParams={{ route: '/statistics' }} location={location}>
        <Card>
          <ViewTitle title={translate('statistics.title')} className="statistics-viewtitle" />
          <div className="statistics-container">
            {
              this.state.isLoadingState ? (
                <div className="inital-loading-container">
                  <CircularProgress size={60} thickness={7} />
                </div>
              ) : (
                <div className="form-container">
                  <div className="field-wrapper">
                    <SelectField
                      value={market}
                      onChange={this.handleMarketChange}
                      floatingLabelText={translate('statistics.selectMarket')}
                    >
                      {
                        markets && markets.map((mrkt) => (
                          <MenuItem
                            key={mrkt.countryCode}
                            primaryText={translate(`statistics.${mrkt.countryCode}`)}
                            value={mrkt}
                          />
                        ))
                      }
                    </SelectField>
                  </div>
                  <RadioButtonGroup
                    onChange={this.handleRadioGuestsChange}
                    defaultSelected="sales"
                    className="guests--radio-group"
                  >
                    <RadioButton value="sales" label={translate('statistics.sales')} />
                    <RadioButton value="guests" label={translate('statistics.guestsAmount')} />
                  </RadioButtonGroup>
                  {
                    market && (
                      <div className="statistics-component-container">
                        <VenueComponent
                          {...this.props}
                          market={market}
                          venues={venues}
                          venuesByMarket={venuesByMarket}
                          areaManagers={areaManagers}
                          handleVenuesChange={this.handleVenuesChange}
                        />
                        {
                          tabbedState === 'guests' ? (
                            <GuestsComponent
                              {...this.props}
                              handleSeatingChange={this.handleSeatingChange}
                              handleBookingsChange={this.handleBookingsChange}
                            />
                          ) : (
                            <ProductComponent
                              {...this.props}
                              market={market}
                              products={products}
                              productsByMarket={productsByMarket}
                              categoriesByMarket={categoriesByMarket}
                              initialCategories={initialCategories}
                              handleProductsChange={this.handleProductsChange}
                            />
                          )
                        }
                      </div>
                    )
                  }

                  <div className="field-wrapper dates-container">
                    <div className="dates-wrapper">
                      <h2 className="dates--h2">{translate('statistics.date')}</h2>
                      <div className="dates--fields">
                        <DPicker
                          key="pickerFrom"
                          label={translate('statistics.from')}
                          onChange={this.onDateFromChange}
                          inline
                          placeholder={translate('statistics.from')}
                          value={dateFrom}
                        />
                        <DPicker
                          key="pickerTo"
                          label={translate('statistics.to')}
                          onChange={this.onDateToChange}
                          inline
                          placeholder={translate('statistics.to')}
                          value={dateTo}
                        />
                        {/* <DatePicker
                        autoOk
                        hintText="From"
                        floatingLabelText={translate('statistics.from')}
                        container="inline"
                        onChange={this.onDateFromChange}
                        value={this.state.dateFrom}
                        // openToYearSelection
                      />
                      <DatePicker
                        autoOk
                        hintText="To"
                        floatingLabelText={translate('statistics.to')}
                        container="inline"
                        mode="landscape"
                        onChange={this.onDateToChange}
                        value={this.state.dateTo}
                        // openToYearSelection
                      /> */}
                      </div>
                    </div>
                    <div className="interval-wrapper">
                      <h3 className="interval--h3">{translate('statistics.interval')}</h3>
                      <div className="dates--fields dates--interval-select-field">
                        <SelectField value={this.state.period} onChange={this.handlePeriodChange} floatingLabelText={translate('statistics.period')}>
                          <MenuItem key="minutewise" primaryText={translate('statistics.minutewise')} value="minutewise" />
                          <MenuItem key="hourly" primaryText={translate('statistics.hourly')} value="hourly" />
                          <MenuItem key="daily" primaryText={translate('statistics.daily')} value="daily" />
                          <MenuItem key="weekly" primaryText={translate('statistics.weekly')} value="weekly" />
                          <MenuItem key="monthly" primaryText={translate('statistics.monthly')} value="monthly" />
                          <MenuItem key="quarterly" primaryText={translate('statistics.quarterly')} value="quarterly" />
                          <MenuItem key="yearly" primaryText={translate('statistics.yearly')} value="yearly" />
                        </SelectField>
                      </div>
                    </div>

                    {/* <div style={{ maxWidth: '150px', padding: '10px 0 10px 0' }}>
                    <Toggle
                      label="Per Guest"
                      onToggle={() => this.setState((prevState) => ({ perGuest: !prevState.perGuest }))}
                      toggled={this.state.perGuest}
                    />
                  </div> */}
                  </div>

                  <Checkbox label={translate('statistics.downloadCSV')} className="csv--checkbox" checked={this.state.download} onCheck={this.handleOnCheck} />
                  <RaisedButton className="query-button" label={translate('statistics.query')} onClick={this.handleSubmit} />

                  <PivotTable onChange={this.pivotHandleChange} d={this.state[`${tabbedState}-data`]} state={this.state.s} options={this.state[`${tabbedState}-pivotOptions`]} {...this.state} />
                </div>
              )
            }

            {
              this.state.isLoadingFetch &&
              <div className="fetch-loading-container">
                <div className="fetch-loading-div">
                  <h3 className="fetch-loading-title">{translate('statistics.fetchingData') }</h3>
                  <CircularProgress size={60} thickness={7} />
                </div>
              </div>
            }
          </div>
        </Card>
      </Restricted>
    );
  }
}

const PivotTable = ({ d = [], onChange, state = {}, options = {}, ...props }) => ( // eslint-disable-line
  <React.Fragment>
    <PivotTableUI
      data={d}
      onChange={(s) => onChange(s)}
      renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
      aggregatorName="Sum"
      unusedOrientationCutoff={999999999999999}
      // aggregators={{ ...aggregators, TotalSales: aggTest }}
      // aggregators={{ count: () => {console.log('count')}, agg: (attr) => aggTest(attr) }}
      // aggregatorName="count"
      vals={props.tabbedState === 'guests' ? ['Guests'] : ['Units(Pcs)']}
      {...state}
      {...options}
    />
  </React.Fragment>
);

// tests for future custom aggregators
// function aggTest(attr) {
//   // const attribute = attr[0];
//   console.log(attr);
//   return function (data, rowKey, colKey) {
//     // console.log('attributeNames', data);
//     return {

//       count: 0,
//       sales: 0,
//       guests: {},
//       push(record) {
//         // console.log(record);
//         this.sales += parseFloat(record.Units);
//         if (this.guests[rowKey] === undefined) {
//           this.guests[rowKey] = {};
//         }
//         if (this.guests[rowKey][colKey] === undefined) {
//           this.guests[rowKey][colKey] = {};
//         }
//         this.guests[rowKey][colKey] = record.Guests;
//       },
//       value() { return this.sales / this.guests[rowKey][colKey]; },
//       format(x) { return x; },
//     };
//   };
// }

export default connect(
  (state) => ({ permissions: get(state, 'auth.permissions'), user: get(state, 'auth.user') }),
  {
    showNotification: showNotificationAction,
  }
)(withRouter(t(Statistics)));
